import type { AdminOverview, AdminUserView, AiCacheListResult, Paginated, UserSettings } from '@en3/shared';
import { api } from './client';
import { toQuery } from './content.api';

/**
 * 后台接口（阶段 7）。全部要求 admin 角色，前端只做"能不能进这个页面"的判断，
 * **真正的权限边界在后端**（每个路由都挂了 `requireRole('admin')`）。
 */

export const adminApi = {
  overview: () => api.get<AdminOverview>('/api/admin/overview'),

  aiCache: (
    params: { page?: number; pageSize?: number; namespace?: string; q?: string; status?: 'ok' | 'error'; days?: number } = {},
  ) => api.get<AiCacheListResult>(`/api/admin/ai-cache${toQuery(params)}`),

  deleteAiCache: (id: string) => api.delete<{ deleted: boolean }>(`/api/admin/ai-cache/${id}`),

  users: (params: { page?: number; pageSize?: number; q?: string; role?: string; status?: string } = {}) =>
    api.get<Paginated<AdminUserView>>(`/api/admin/users${toQuery(params)}`),

  updateUser: (id: string, body: { role?: string; status?: string }) =>
    api.patch<{ user: AdminUserView }>(`/api/admin/users/${id}`, body),

  /** 装载内置教材目录（幂等）。 */
  seedTextbooks: () => api.post<{ textbooks: number; units: number }>('/api/textbooks/seed'),
};

/** 用户设置（个人中心可改；后端 `/api/me` 返回 `settings`）。 */
export type { UserSettings };
